import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database'; // If using Firebase database

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAe6fhE-0Y3AY9D1cwwbk7Rlp5iMlAIS30",
    authDomain: "variantpoll.firebaseapp.com",
    projectId: "variantpoll",
    storageBucket: "variantpoll.appspot.com",
    messagingSenderId: "788334001682",
    appId: "1:788334001682:web:85915b4214558d3189a2cb",
    measurementId: "G-NNZPTBFG9F"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
  
export default db;
  